import React, { lazy, Suspense, useState } from "react";
import { Container, Row, Col, Image, Navbar } from "react-bootstrap";
import "./Combined.css";
import Memories from "../MemoryHighlight/MemoriesHighlight";
import Highlights from "../VideoHighlights/videoHighlights";
import htmlParser from 'html-react-parser';

export default function Combined({ links }) {

  return (
    <>
      <div className="combined-carousel">


        <div className="combined-heading">
          <div className="first-part pt-5 pb-5">Highlights From </div>
          <div className="second-part pt-5 pb-5">&nbsp;Prior Events</div>
        </div>
        <div className="carousel-section">
          <div className="highlights-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Highlights />
          </div>
          <div className="memories-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Memories />
          </div>
        </div>
      </div>

      {/* <p className="disclaimer"> Jason Oppenheim is a paid spokesperson for <a href="https://celligence.com/" target="_blank">Celligence International, LLC</a>, the creators of AngelAi.</p> */}
        <p className="disclaimer1"> Ivan Rodriguez is a paid spokesperson for<a href="https://www.swmc.com/" target="_blank"> Sun West Mortgage Company, Inc.</a></p>
    </>
  );
}
